var _rect, _rect2, _path, _path2, _ellipse, _path3, _path4, _path5, _path6, _path7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSafeAndSecure(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 350,
    height: 350,
    viewBox: "0 0 350 350",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 277.711,
    y: 64.3645,
    width: 164.367,
    height: 209.789,
    rx: 12.5,
    transform: "rotate(90 277.711 64.3645)",
    fill: "white",
    stroke: "#102F5D",
    strokeWidth: 15
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 259.729,
    y: 83.22,
    width: 126.657,
    height: 173.825,
    transform: "rotate(90 259.729 83.22)",
    fill: "#102F5D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M61.917 255.298L30 277.136H320L288.083 255.298H61.917Z",
    fill: "#102F5D",
    stroke: "#102F5D",
    strokeWidth: 15,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M74.7607 122.246C54.9145 126.53 42.2984 146.091 46.5817 165.937L47.2295 168.938C43.4221 172.295 41.4941 177.558 42.6412 182.872L53.698 234.102C55.386 241.924 63.0949 246.896 70.9163 245.208L129.831 232.492C137.652 230.804 142.624 223.095 140.936 215.274L129.879 164.044C128.659 158.387 124.288 154.221 119.004 152.986L118.451 150.425C114.168 130.579 94.6069 117.963 74.7607 122.246ZM90.9811 156.354L91.2416 157.561L74.3121 161.215L74.0516 160.008C73.0426 155.333 76.0145 150.725 80.6894 149.716C85.3644 148.707 89.9721 151.679 90.9811 156.354Z",
    fill: "#102F5D",
    stroke: "white",
    strokeWidth: 15
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 91.7303,
    cy: 200.873,
    rx: 23.5843,
    ry: 13.9759,
    transform: "rotate(-12.1791 91.7303 200.873)",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M115.292 117.34L116.456 120.953L110.956 122.786L114.711 128.124L111.697 130.389L107.731 124.781L103.712 130.389L100.698 128.124L104.4 122.894L99.0061 121.061L100.169 117.448L105.88 119.335V112.919H109.582V119.227L115.292 117.34Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M138.013 117.34L139.177 120.953L133.677 122.786L137.432 128.124L134.418 130.389L130.452 124.781L126.433 130.389L123.419 128.124L127.121 122.894L121.727 121.061L122.89 117.448L128.601 119.335V112.919H132.303V119.227L138.013 117.34Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M160.734 117.34L161.898 120.953L156.398 122.786L160.153 128.124L157.139 130.389L153.173 124.781L149.154 130.389L146.14 128.124L149.842 122.894L144.448 121.061L145.611 117.448L151.322 119.335V112.919H155.024V119.227L160.734 117.34Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M183.095 136.88C181.044 136.775 179.264 138.401 179.373 140.471C180.597 163.76 189.798 184.29 204.067 196.989C205.028 197.844 206.399 198.036 207.557 197.479C224.756 189.201 239.226 171.997 246.783 149.941C247.454 147.982 246.189 145.927 244.188 145.464C233.675 143.028 224.608 138.142 218.569 128.609C217.238 126.507 214.2 126.08 212.344 127.734C203.927 135.237 193.871 137.436 183.095 136.88Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M161.374 141.974C162.841 169.008 173.714 194.21 192.252 210.528C198.567 216.086 207.586 217.348 215.184 213.738C237.494 203.139 254.877 181.893 263.72 156.302C268.256 143.173 259.318 131.255 248.267 128.712C240.705 126.973 236.34 124.09 233.516 119.685C226.286 108.409 210.531 106.205 200.482 115.06C196.555 118.521 191.564 120.094 183.815 119.691C172.492 119.101 160.622 128.105 161.374 141.974ZM206.875 189.598C196.284 179.204 188.896 163.415 186.994 145.03C196.507 144.889 205.95 142.588 214.339 136.363C220.693 144.651 229.139 149.456 238.246 152.203C231.362 169.358 219.917 182.512 206.875 189.598Z",
    fill: "#102F5D",
    stroke: "white",
    strokeWidth: 15
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSafeAndSecure);
export default __webpack_public_path__ + "static/media/safe-and-secure.61670099a3b47f3254f2795e9efa440b.svg";
export { ForwardRef as ReactComponent };